import { render, staticRenderFns } from "./cardForca.vue?vue&type=template&id=d9ffb9ee"
import script from "./cardForca.vue?vue&type=script&lang=js"
export * from "./cardForca.vue?vue&type=script&lang=js"
import style0 from "./cardForca.vue?vue&type=style&index=0&id=d9ffb9ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports